import { render, staticRenderFns } from "./AppFilterSectionCategoryFilter.vue?vue&type=template&id=513b0e3c&scoped=true"
import script from "./AppFilterSectionCategoryFilter.vue?vue&type=script&lang=js"
export * from "./AppFilterSectionCategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./AppFilterSectionCategoryFilter.vue?vue&type=style&index=0&id=513b0e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b0e3c",
  null
  
)

export default component.exports